class Localization extends HTMLElement {
  constructor() {
    super();
    this.isDropDownOpen = false;

    this.button = this.querySelector(".languageButton");
    this.panel = this.querySelector(".language-dropdown");
    this.optionEls = this.querySelectorAll(".language-option");
    this.linkEls = this.querySelectorAll(".language-link");
    this.currentLangEl = this.querySelector(".current-lang");

    if (!this.button || !this.panel) return;

    this.handleDropDown = this.handleDropDown.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onLinkClick = this.onLinkClick.bind(this);
    this.button.addEventListener("click", this.handleDropDown);
    document.addEventListener("click", this.onDocClick);
    this.optionEls.forEach((li) => li.addEventListener("click", this.onOptionClick));
    this.linkEls.forEach((link) => link.addEventListener("click", this.onLinkClick));
  }

  connectedCallback() {
    this.populateLangCodes();
    this.updateCurrentLanguageUI();
  }

  handleDropDown(e) {
    e.preventDefault();
    if (this.isDropDownOpen) this.hidePanel();
    else this.showPanel();
  }

  showPanel() {
    this.classList.add("dropdown-active");
    this.panel.removeAttribute("hidden");
    this.isDropDownOpen = true;
    this.button.setAttribute("aria-expanded", "true");
  }

  hidePanel() {
    this.classList.remove("dropdown-active");
    this.panel.setAttribute("hidden", "");
    this.isDropDownOpen = false;
    this.button.setAttribute("aria-expanded", "false");
  }

  onDocClick(e) {
    if (!e.target.closest("localization-component")) {
      if (this.isDropDownOpen) this.hidePanel();
    }
  }
  navigateFromEl(el) {
    let url = el?.getAttribute("link").toLowerCase();
    if (url) window.location.href = url;
  }
  onLinkClick(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    e.preventDefault();
    e.stopPropagation();
    this.navigateFromEl(e.currentTarget);
  }
  onOptionClick(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    e.preventDefault();
    const link = e.currentTarget.querySelector(".language-link");
    this.navigateFromEl(link);
  }
	populateLangCodes() {
		this.querySelectorAll(".lang-code").forEach((span) => {
			const parent = span.closest(".language-link");
			if (!parent) return;
			span.textContent = parent.dataset.code || parent.getAttribute("lang") || "";
		});
	}
	updateCurrentLanguageUI() {
		if (!this.currentLangEl) return;

		const path = (window.location.pathname || "/").replace(/^\/+/, "").toLowerCase();

		const activeLink = Array.from(this.linkEls).find((el) => {
			const match = (el.dataset.match || "").toLowerCase();
			return match && path.startsWith(match);
		});

		this.optionEls.forEach((li) => li.classList.remove("active"));
		if (activeLink) activeLink.closest(".language-option")?.classList.add("active");

		if (activeLink) {
			const code = activeLink.dataset.code || activeLink.getAttribute("lang") || "DE";
			const flagEl = activeLink.querySelector(".country-flags");
			const flagHTML = flagEl ? flagEl.outerHTML : "";
			this.currentLangEl.innerHTML = `${flagHTML} <span class="current-lang-text">${code}</span>`;
		} else {
			this.currentLangEl.innerHTML =
				`<span class="country-flags country-flags--DE"></span> <span class="current-lang-text">DE</span>`;
		}
	}
}
customElements.get('localization-component') ||
customElements.define('localization-component', Localization);
